/**
 * Resolves a full local disk path from the project root and an optional relative path.
 */
export function resolveLocalPath(
  projectDirPath: string | null,
  relativePath?: string
): string | null {
  if (!projectDirPath) {
    return null;
  }

  if (!relativePath) {
    return projectDirPath;
  }

  return `${projectDirPath}/${relativePath}`;
}
